'use client';

import { useRouter } from 'next/navigation';
import { useState } from 'react';

import { PageChangeDataProps, Pagination } from '@/slw/widgets/common/pagination';
import { ResponseMeta } from '@/slw/shared/types/api.type';
import { ListingByUser } from '@/slw/entities/buyer/dealer-listings/dealer-listings.type';
import { Input } from '@/slw/shared/ui/input';

import { ListingItem } from './listing-item.ui';

interface DealerListingsProps {
  listings: ListingByUser[];
  metaData: ResponseMeta;
  keyword: string;
  slug: string;
}

export function DealerListings({ listings, metaData, keyword, slug }: DealerListingsProps) {
  const [search, setSearch] = useState<string>(keyword);
  const router = useRouter();

  const onSearch = () => {
    router.replace(`/dealer-listings/${slug}?page=1&keyword=${search || ''}`);
  };

  const onPageChange = ({ page }: PageChangeDataProps) => {
    router.replace(`/dealer-listings/${slug}?page=${page}&keyword=${keyword || ''}`);
  };

  const totalCount = metaData?.totalItems ?? 0;
  const pageSize = metaData?.pageSize ?? 21;
  const pageIndex = metaData?.pageIndex ?? 1;

  return (
    <>
      <div className='flex flex-col lg:flex-row items-center justify-between mb-8'>
        <h2 className='text-[1.5rem] md:text-[2.5rem] lg:text-[2.5rem] font-bold mb-5 lg:mb-1 text-center lg:text-left'>
          Vehicles for Sale by Dealer
        </h2>
        <div className='relative'>
          <button type='button' className='absolute p-3 top-1/2 -translate-y-1/2' onClick={onSearch}>
            <img src='/images/common/ic-search.png' alt='' />
          </button>
          <Input
            className='h-[2.5rem] md:h-[3.25rem] px-10 rounded-md focus-visible:ring-0 max-w-[300px] text-sm'
            type='text'
            placeholder='Search...'
            value={search || ''}
            onChange={(e) => setSearch(e.target.value || '')}
          />
        </div>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 xl:gap-6'>
        {listings.map((listing, idx) => (
          <ListingItem key={`${listing.id}_${idx}`} listing={listing} />
        ))}
      </div>

      {!!listings && !!listings.length && (
        <div className='mt-8'>
          <Pagination currentPage={pageIndex} totalItems={totalCount} pageSize={pageSize} onPageChange={onPageChange} />
        </div>
      )}
    </>
  );
}
